"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { submitQueryAction } from "../../../services/action/common";

const QueryModal = ({ setShowQueryModal, leadDetails }) => {
  const [queryDescription, setQueryDescription] = useState("");
  const { user } = useSelector((state) => state.authenticationReducer);
  const dispatch = useDispatch();
  const submitQuery = () => {
    dispatch(
      submitQueryAction({
        userType: user?.userType?.toLowerCase(),
        data: {
          leadId: leadDetails?._id,
          query: queryDescription,
        },
        cb: () => {
          setShowQueryModal(false);
        },
      })
    );
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[500px] shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold text-[#00234a]">Submit Query</h3>
          <button
            onClick={() => setShowQueryModal(false)}
            className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description <span className="text-red-500">*</span>
            </label>
            <textarea
              value={queryDescription}
              onChange={(e) => setQueryDescription(e.target.value)}
              placeholder="Describe your query in detail..."
              className="w-full border rounded-lg p-2 h-32 focus:outline-none focus:ring-2 focus:ring-[#00234a]"
            />
          </div>
        </div>
        <button
          onClick={submitQuery}
          className="w-full bg-[#00234a] text-white py-3 rounded-lg hover:bg-[#001a38] transition-colors font-medium"
        >
          SUBMIT QUERY
        </button>
      </div>
    </div>
  );
};

export default QueryModal;
